import app from 'flarum/common/app';
import copyToClipboard from '../util/copyToClipboard';
export const handleCopyIP = ip => {
  return () => {
    copyToClipboard(ip);
    app.alerts.show({
      type: 'success'
    }, app.translator.trans('fof-geoip.lib.alerts.ip_copied'));
  };
};
flarum.reg.add('fof-geoip', 'common/helpers/ClipboardHelper', { handleCopyIP: handleCopyIP, });